import React, { useState } from 'react'

const FILTERS = [
    { value: 'all', label: 'Whole Team', match: null },
    { value: 'admins', label: 'Admins', match: 'admin' },
    { value: 'rsos', label: 'RSOS', match: 'rso' },
    { value: 'nurses', label: 'Nurses', match: 'nurse' },
    { value: 'doctors', label: 'Doctors', match: 'doctor' },
];

function initialsOf(name) {
    if (!name) return '?';
    return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');
}

function MemberCard({ members = [] }) {
    const [filter, setFilter] = useState('all');

    const activeFilter = FILTERS.find((f) => f.value === filter);
    const filteredMembers = activeFilter?.match
        ? members.filter((item) => item?.member?.role?.role_name?.toLowerCase().includes(activeFilter.match))
        : members;

    return (
        <div>
            <div className="flex flex-wrap gap-2 mb-4">
                {FILTERS.map((f) => (
                    <button
                        key={f.value}
                        onClick={() => setFilter(f.value)}
                        className={`border rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
                            filter === f.value
                                ? 'bg-seha-500 text-white border-seha-500'
                                : 'bg-white text-neutral-600 border-neutral-200 hover:bg-neutral-50'
                        }`}
                    >
                        {f.label}
                    </button>
                ))}
            </div>

            <div className="space-y-3">
                {filteredMembers.length === 0 && (
                    <p className="text-sm text-neutral-400 text-center py-6">No members found.</p>
                )}
                {filteredMembers.map((item, idx) => (
                    <div
                        key={item?.member?.id ?? idx}
                        className="flex items-center gap-3 p-2.5 rounded-lg border border-neutral-100 hover:bg-neutral-50 hover:border-neutral-200 transition-colors"
                    >
                        <div className="w-10 h-10 rounded-full bg-seha-50 text-seha-700 border border-seha-100 flex items-center justify-center font-bold text-sm shrink-0">
                            {initialsOf(item?.member?.fullname)}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-bold text-neutral-800 truncate">{item?.member?.fullname}</p>
                            <p className="text-xs text-neutral-500 truncate">
                                {item?.member?.role?.role_name || 'N/A'} &middot; {item?.member?.mobile || '—'}
                            </p>
                            <p className="text-[11px] text-neutral-400 mt-0.5">
                                ETA {item?.eta || '10 minutes'} &middot; {item?.distance || '15 km'}
                            </p>
                        </div>
                        <span
                            className={`w-2.5 h-2.5 rounded-full ring-2 ring-white shrink-0 ${
                                item?.accepted ? 'bg-green-500' : 'bg-yellow-500'
                            }`}
                            title={item?.accepted ? 'Accepted' : 'Pending'}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MemberCard
